import { ProgramDocumentRequest } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createProgramDocument: (
  fetchContext: FetchContext,
  programDocument: ProgramDocumentRequest,
  accessToken?: string,
) => Promise<number> = async (fetchContext, programDocument, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/program-documents`,
  {
    method: 'POST',
    body: JSON.stringify(programDocument),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<number>(fetchContext.errorStore, response, 'create program document', !response.ok, [], true));
